import { Grid, Typography, Divider, Avatar } from "@material-ui/core";
import { CollectibleStyles } from "./collectible.styles";
import { type CollectibleType } from "../../../models/collectible";
import {
  BookIcon,
  PodcastIcon,
  FruitionIcon,
  ArticleIcon,
  CommunityIcon,
} from "../../../shared/icons";
import { Title } from "./collectible.const";

interface CollectibleProps {
  collectableType: CollectibleType;
  title: string;
  assignedByFullName: string;
  contentLink: string;
  id?: string;
}

const RenderIcon = ({ type, className }) => {
  if (type === "Book")
    return <BookIcon width="18" height="20" className={className} />;
  if (type === "Podcast") return <PodcastIcon />;
  if (type === "Community Post") return <CommunityIcon className={className} />;
  if (type === "Article" || type === "Other" || type === "Calculator")
    return <ArticleIcon />;
  return null;
};

export const Collectible = ({
  collectableType,
  title,
  assignedByFullName,
  contentLink,
  id,
}: CollectibleProps) => {
  const classes = CollectibleStyles({ collectableType });

  const onClick = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <Grid
      container
      className={classes.root}
      data-testid="collectible-card"
      onClick={() => onClick(contentLink)}
      id={id}
    >
      <Grid container className={classes.container} direction="column">
        <Grid container justifyContent="flex-start" alignItems="center">
          <RenderIcon type={collectableType} className={classes.icon} />
          <Typography className={classes.typeLabel}>
            {collectableType}
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between" direction="column">
          <Typography className={classes.title}>
            {Title(collectableType, title)}
          </Typography>
          <Divider className={classes.divider} />
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid item xs={4} container>
            <Avatar className={classes.avatar}>
              <FruitionIcon />
            </Avatar>
          </Grid>
          <Grid item xs={8} container>
            <Typography className={classes.postedBy}>Shared by</Typography>
            <Typography className={classes.name}>
              {assignedByFullName}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
